// import React, { useEffect } from 'react'
// import { useDispatch } from 'react-redux'
// import { setSelectedCashRegister } from '../../../redux/slices/cashRegisterSlice'
// import { useLocation, useNavigate } from 'react-router-dom'

// const CashRegister = () => {
//   const dispatch=useDispatch()
//   const location = useLocation();
//   const data = location.state || {};
//   const navigate=useNavigate()
//   useEffect(()=>{

//   },[])
//   const handleClick=()=>{
//     dispatch(setSelectedCashRegister(true))
//     navigate(data)
//   }
//   return (
//     <div onClick={handleClick}>CashRegister</div>
//   )
// }

// export default CashRegister

// import { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation, useNavigate } from "react-router-dom";
// import { setCashRegisters, setSelectedCashRegister } from "../../../redux/slices/cashRegisterSlice";
// import Searchbar from "../../controls/Searchbar";
// import { fetchCashRegister } from "../../../api/CashRegisterApi";
// import { SalesDB } from "../newSales/offlineMode/indexedDB";

// const CashRegister = () => {
//   const [loading, setLoading] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const cashRegister = useSelector((state) => state.cashRegister);
//   const dispatch = useDispatch();
//   const [cashData, setCashData] = useState(cashRegister?.cashRegisters || []);
//   const [searchCashData, setSearchCashdata] = useState(cashData);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const data = location.state || {};
//   const store = useSelector((state) => state.store.store);
//   // const fetchCashRegister = async () => {
//   //   try {
//   //     setLoading(true)
//   //     const data = await fetchCashRegister(store.key);
//   //     setCashData(data.cashRegisters)
//   //     dispatch(setCashRegisters(data.cashRegisters)); 
//   //   } catch (err) {
//   //     console.log(err, "while fetching cash register");
//   //   }
//   //   finally{
//   //     setLoading(false)
//   //   }
//   // };


//   const salesDB=new SalesDB();
//   const fetchCashRegister = async () => {
//     try {
//       setLoading(true);
//       await salesDB.openDB(); // Open the database
//       const cachedCashRegisterData = await salesDB.getAllData("cashRegisters");
//       console.log(cachedCashRegisterData, "I am cached cash register data");
  
//       if (cachedCashRegisterData && cachedCashRegisterData.length > 0) {
//         setCashData(cachedCashRegisterData);
//         dispatch(setCashRegisters(cachedCashRegisterData));
//       } else {
//         const data = await fetchCashRegister(store.key);
//         if (data.message === "success") {
//           setCashData(data.cashRegisters);
//           dispatch(setCashRegisters(data.cashRegisters));
//           await salesDB.addBatchData("cashRegisters", data.cashRegisters); // Store data in IndexedDB
//           console.log("Cash register data loaded and cached.");
//         }
//       }
//     } catch (err) {
//       console.log(err, "while fetching cash register");
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   const handleInputChange = (newValue) => {
//     // console.log("Input value changed:", newValue);
//     setSearchQuery(newValue);
//   };

//   const handleClickCash = (cashRegister) => {
//     dispatch(setSelectedCashRegister(cashRegister));
//     navigate(data);
//   };

//   useEffect(() => {
//     if (searchQuery.trim() === "") {
//       setSearchCashdata(cashData);
//     } else {
//       setSearchCashdata(
//         cashData.filter((cash) =>
//           cash?.CashRegisterName?.toLowerCase().includes(searchQuery.toLowerCase())
//         )
//       );
//     }
//   }, [searchQuery, cashData]);

//   useEffect(()=>{
//     fetchCashRegister()
//   },[store.key])

//   return (
//     <div className="fixed z-100 inset-0 flex justify-center items-center bg-[#ACB4C0] h-screen w-full">
//       <div className="bg-white w-full max-w-sm rounded-xl max-h-[80vh] h-[80vh] custom-scrollable overflow-y-auto">
//         <h1 className="text-xl font-medium text-gray-500 px-5 py-5 border-b-1 border-gray-200">
//           Store Selection
//         </h1>
//         <div className="mt-5 px-4 mb-2">
//           <Searchbar
//             value={searchQuery}
//             onChange={handleInputChange}
//             placeholder="Search for store..."
//           />
//         </div>
//         <div>
//           {loading ? (
//             <p>Loading...</p>
//           ) : (
//             searchCashData?.map((cash, index) => (
//               <div
//                 key={index}
//                 onClick={() => handleClickCash(cash)}
//                 className="capitalize px-5 text-sm text-gray-600 hover:bg-gray-100 w-full py-4 cursor-pointer font-medium border-b border-gray-200"
//               >
//                 {cash.CashRegisterCode
//                 } {cash.CashRegisterName
//                   }
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CashRegister;


import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setCashRegisters, setSelectedCashRegister } from "../../../redux/slices/cashRegisterSlice";
import Searchbar from "../../controls/Searchbar";
import { fetchCashRegister } from "../../../api/CashRegisterApi";

const CashRegister = () => {
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const cashRegister = useSelector((state) => state.cashRegister);
  const dispatch = useDispatch();
  const [cashData, setCashData] = useState(cashRegister?.cashRegisters || []);
  const [searchCashData, setSearchCashdata] = useState(cashData);
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state || {};
  const store = useSelector((state) => state.store.store);

  const fetchCashRegister = async () => {
    try {
      setLoading(true);
      const data = await fetchCashRegister(store.key);
      if (data.message === "success") {
        
        setCashData(data.cashRegisters);
        dispatch(setCashRegisters(data.cashRegisters));
        console.log("Cash register data loaded.");
      }
    } catch (err) {
      console.log(err, "while fetching cash register");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (newValue) => {
    setSearchQuery(newValue);
  };

  const handleClickCash = (cashRegister) => {
    dispatch(setSelectedCashRegister(cashRegister));
    navigate(data);
  };

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setSearchCashdata(cashData);
    } else {
      setSearchCashdata(
        cashData.filter((cash) =>
          cash?.CashRegisterName?.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }
  }, [searchQuery, cashData]);

  useEffect(() => {
    fetchCashRegister();
  }, [store.key]);

  return (
    <div className="fixed z-100 inset-0 flex justify-center items-center bg-[#ACB4C0] h-screen w-full">
      <div className="bg-white w-full max-w-sm rounded-xl max-h-[80vh] h-[80vh] custom-scrollable overflow-y-auto">
        <h1 className="text-xl font-medium text-gray-500 px-5 py-5 border-b-1 border-gray-200">
          Store Selection
        </h1>
        <div className="mt-5 px-4 mb-2">
          <Searchbar
            value={searchQuery}
            onChange={handleInputChange}
            placeholder="Search for store..."
            hideRefresh={true}
          />
        </div>
        <div>
          {loading ? (
            <p>Loading...</p>
          ) : (
            searchCashData?.map((cash, index) => (
              <div
                key={index}
                onClick={() => handleClickCash(cash)}
                className="capitalize px-5  text-gray-600 hover:bg-gray-100 w-full py-4 cursor-pointer font-medium border-b border-gray-200"
              >
                {cash.CashRegisterCode} {cash.CashRegisterName}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default CashRegister;